module.exports = __webpack_public_path__ + "static/media/reservationTime60.197e2aa2.svg";